import styled from 'styled-components';

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 7px;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  background-color: #bbbbbb;
`;

export const ProgressBarSegment = styled.div`
  height: 100%;
  line-height: 27px;
  color: white;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  background-color: ${(props) => props.color};
  width: ${(props) => `${props.percentage}%`};
  position: absolute;
  top: 0;
  left: ${(props) => props.offset || 0}%;
`;
